// Translation type definition
// This file defines the shape of all translation objects

export interface Translation {
  finalizeBooking: string;
  confirmBooking: string;
  bookingInProgress: string;
  selectServiceMethod: string;
  visitStore: string;
  visitStoreSubtitle: string;
  pickupService: string;
  pickupServiceSubtitle: string;
  storeBonus: string;
  storeCredit: string;
  free: string;
  shipByPost: string;
  shipByPostSubtitle: string;
  selectLocation: string;
  selectDate: string;
  selectTime: string;
  selecteerDatum: string;
  selecteerTijd: string;
  pickupCostInfo: string;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  sunday: string;
  closed: string;
  selectDeviceTitle: string;
  selectDeviceSubtitle: string;
  phonesTablets: string;
  ipadDevices: string;
  computers: string;
  bestDeal: string;
  mostChosen: string;
  modelsAvailable: string;
  safeAndReliable: string;
  repairTab: string;
  sellTab: string;
  repairCtaTitle: string;
  repairCtaText: string;
  startRepair: string;
  popularTag: string;
  paidOutIn2024: string;
  chooseYour: string;
  estimatedPrice: string;
  onRequest: string;
  priceOnRequest: string;
  iPhoneHint: string;
  samsungHint: string;
  iPadHint: string;
  macBookHint: string;
  appleWatchHint: string;
  iMacHint: string;
  nextStepInfo: string;
  continueWithSelling: string;
  sellAnotherDevice: string;
  whyChoosePhoneBros: string;
  shippingHassleFreTitle: string;
  shippingHassleFreText: string;
  dataSecureTitle: string;
  dataSecureText: string;
  trustedTitle: string;
  trustedText: string;
  humanContactTitle: string;
  humanContactText: string;
  startChat: string;
  appointmentAt: string;
  on: string;
  pickupAt: string;
  private: string;
  business: string;
  vatNumber: string;
  companyName: string;
  registeredOffice: string;
  firstName: string;
  lastName: string;
  alternativePhone: string;
  notes: string;
  notesPlaceholder: string;
  acceptTerms: string;
  termsConditions: string;
  acceptPrivacy: string;
  newerModelsImpact: string;
  deviceAgeImpact: string;
  realtimeAnalysisWarning: string;
  valueDropsFasterThanExpected: string;
  valueEvolution: string;
  realtimeMarketAnalysis: string;
  expectedDecline: string;
  potentialLossWaiting: string;
  deviceValueDropsQuickly: string;
  dropsQuicklyAccordingToAnalysis: string;
  sellNowEarnMore: string;
  moreProfit: string;
  aiPrediction: string;
  basedOnMarketData: string;
  settings: string;
  general: string;
  iphoneStorage: string;
  requestQuote: string;
  comingSoon: string;
  comingSoonText: string;
  stepTwo: string;
  searchPlaceholder: string;
  sortBy: string;
  popularFirst: string;
  priceHighToLow: string;
  priceLowToHigh: string;
  nameAZ: string;
  nameZA: string;
  back: string;
  previousQuestion: string;
  nextQuestion: string;
  selectSpecifications: string;
  storage: string;
  version: string;
  battery: string;
  networkType: string;
  condition: string;
  conditionExcellent: string;
  conditionGood: string;
  conditionFair: string;
  conditionDefective: string;
  price: string;
  addToCart: string;
  step3: string;
  selectPropertiesOf: string;
  device: string;
  type: string;
  properties: string;
  tradeInTool: string;
  sell: string;
  estimatedValue: string;
  estimation: string;
  whatScreenSize: string;
  selectScreenSize: string;
  fromWhatYear: string;
  selectProductionYear: string;
  selectProcessor: string;
  chooseProcessorType: string;
  howMuchStorage: string;
  chooseStorageCapacity: string;
  howMuchRam: string;
  selectRamAmount: string;
  doYouHaveAccessories: string;
  selectOriginalAccessories: string;
  whatConnectionType: string;
  chooseWifiOrCellular: string;
  whatBatteryCondition: string;
  findBatteryCondition: string;
  whatConditionIs: string;
  assessExteriorCondition: string;
  whatSizeWatch: string;
  selectWatchSize: string;
  whatBandWatch: string;
  selectBandType: string;
  watchHasCellular: string;
  selectWatchWifiOrCellular: string;
  cart: string;
  cartTitle: string;
  cartEmpty: string;
  continueShopping: string;
  quantity: string;
  removeFromCart: string;
  total: string;
  nextStep: string;
  selectedDevices: string;
  selectedDevice: string;
  selectAll: string;
  yourEstimatedPrice: string;
  estimationBadge: string;
  chosenOptions: string;
  deviceSpecifications: string;
  showDetails: string;
  hideDetails: string;
  specStorage: string;
  specBattery: string;
  specBatteryHealth: string;
  specNetwork: string;
  specCondition: string;
  specFunctionality: string;
  specScreen: string;
  specHousing: string;
  specQuantity: string;
  specPrice: string;
  specScreenSize: string;
  specModelYear: string;
  specProcessor: string;
  specRam: string;
  specAccessories: string;
  specWatchSize: string;
  specWatchBand: string;
  specCellular: string;
  storageImpactLow: string;
  conditionImpact: string;
  batteryImpactLow: string;
  termsAndConditions: string;
  aboutUs: string;
  contact: string;
  whyPhoneBros: string;
  instantValuation: string;
  certifiedDataDeletion: string;
  freePickupService: string;
  professionalQualityControl: string;
  contactSupport: string;
  followUs: string;
  followUsDescription: string;
  businessHours: string;
  performance2024: string;
  satisfiedCustomers: string;
  averageScore: string;
  avgHandling: string;
  openingHours: string;
  paidOut: string;
  avgProcessing: string;
  madeBy: string;
  termsTitle: string;
  privacyTitle: string;
  homeTitle: string;
  homeSubtitle: string;
  startNow: string;
  howItWorks: string;
  close: string;
  stepOf: string;
  previous: string;
  next: string;
  step1Title: string;
  step1Description: string;
  step1ModalDescription: string;
  step1ModalDetail1: string;
  step1ModalDetail2: string;
  step1ModalDetail3: string;
  step1ModalDetail4: string;
  step2Title: string;
  step2Description: string;
  step2ModalDescription: string;
  step2ModalDetail1: string;
  step2ModalDetail2: string;
  step2ModalDetail3: string;
  step2ModalDetail4: string;
  step4Title: string;
  step4ModalDescription: string;
  step4ModalDetail1: string;
  step4ModalDetail2: string;
  step4ModalDetail3: string;
  step4ModalDetail4: string;
  step4Helper: string;
  step3Title: string;
  step3Description: string;
  step3ModalDescription: string;
  step3ModalDetail1: string;
  step3ModalDetail2: string;
  step3ModalDetail3: string;
  step3ModalDetail4: string;
  language: string;
  cartEmptyTitle: string;
  cartSignIn: string;
  cartSignInPrompt: string;
  myProfile: string;
  orders: string;
  yourSelection: string;
  account: string;
  startSelling: string;
  orderComplete: string;
  orderNumber: string;
  thankYou: string;
  emailSent: string;
  appointmentDetails: string;
  date: string;
  time: string;
  location: string;
  success: string;
  allDone: string;
  howNext: string;
  orderNumberInfo: string;
  bringDevice: string;
  withOverview: string;
  bringToStore: string;
  weWillCollect: string;
  receiveVoucher: string;
  afterControl: string;
  moreQuestions: string;
  weHelp: string;
  customerService: string;
  alwaysAvailable: string;
  backToHome: string;
  storeMethod: string;
  homeMethod: string;
  customerRef: string;
  storeVisitInfo: string;
  homeVisitInfo: string;
  noDeviceSelected: string;
  discoverValue: string;
  checkDeviceValue: string;
  mostSoldThisWeek: string;
  receiveUpTo: string;
  discoverValueArrow: string;
  newBadge: string;
  stillDoubting: string;
  klantInformatie: string;
  voerDetailsIn: string;
  persoonlijkeGegevens: string;
  voornaam: string;
  achternaam: string;
  email: string;
  telefoon: string;
  telefoonVoorbeeld: string;
  adresgegevens: string;
  straat: string;
  nummer: string;
  bus: string;
  postcode: string;
  plaats: string;
  land: string;
  opmerkingen: string;
  ikAanvaard: string;
  privacyPolicy: string;
  algemeneVoorwaarden: string;
  findMyIphoneUitgeschakeld: string;
  icloudVerwijderd: string;
  verkoopafronden: string;
  overzicht: string;
  aantal: string;
  totaal: string;
  opAanvraag: string;
  vorige: string;
  privacyPolicyTitle: string;
  algemeneVoorwaardenTitle: string;
  findMyIphoneTitle: string;
  icloudTitle: string;
  selectPreference: string;
  pageTitle: string;
  pageSubtitle: string;
  yourDevice: string;
  pickupAddress: string;
  streetAndNumber: string;
  pickupDate: string;
  timeSlot: string;
  kiesUwService: string;
  volgendestap: string;
  pickupDetails: string;
  pickupServiceInfo: string;
  chooseYourModel: string;
  selectExactModel: string;
  selectExactModelMobile: string;
  allModels: string;
  standardModels: string;
  proModels: string;
  plusModels: string;
  miniModels: string;
  proMaxModels: string;
  airModels: string;
  searchModel: string;
  searchModelMobile: string;
  galaxySeries: string;
  galaxyNoteSeries: string;
  galaxyZSeries: string;
  ultraModels: string;
  feModels: string;
  eModels: string;
  foldModels: string;
  flipModels: string;
  seModels: string;
  siliconModels: string;
  retinaModels: string;
  liteModels: string;
  sellButton: string;
  estimatedPriceUpTo: string;
  deviceNotListed: string;
  deviceRequestDescription: string;
  requestDevice: string;
  proposeDifferentModel: string;
  proposeDifferentModelDescription: string;
  proposeModelButton: string;
  startConversation: string;
  expertsReadyToHelp: string;
  name: string;
  fullNamePlaceholder: string;
  emailPlaceholder: string;
  howDoYouWantContact: string;
  callMe: string;
  phonePlaceholder: string;
  message: string;
  messagePlaceholder: string;
  sending: string;
  sendMessage: string;
  messageSent: string;
  thankYouMessage: string;
  viaPhone: string;
  viaEmail: string;
  languageInfo: string;
  languageSupport: string;
  languageSupportNoticeL1: string;
  languageSupportNoticeL2: string;
  contactUs: string;
  contactFormDescription: string;
  contactFormIntro: string;
  phoneNumber: string;
  contactPreference: string;
  cancel: string;
  phone: string;
  confirmDelete: string;
  deleteConfirmMessage: string;
  delete: string;
  standardStorage: string;
  extendedStorage: string;
  maximumStorage: string;
  wifiOnly: string;
  wifiCellular: string;
  batteryAbove85: string;
  batteryBelow85: string;
  batteryUnknown: string;
  batteryAbove85Desc: string;
  batteryBelow85Desc: string;
  batteryUnknownDesc: string;
  conditionExcellentDesc: string;
  conditionGoodDesc: string;
  conditionFairDesc: string;
  conditionPoorDesc: string;
  storageCapacityQuestion: string;
  selectStorageCapacity: string;
  networkTypeQuestion: string;
  networkTypeSubtitle: string;
  batteryStatusQuestion: string;
  batteryStatusSubtitle: string;
  deviceConditionQuestion: string;
  deviceConditionSubtitle: string;
  howToCheckStorage: string;
  checkStorageInstructions: string;
  howToCheckNetwork: string;
  checkNetworkInstructions: string;
  howToCheckBattery: string;
  checkBatteryInstructions: string;
  whichConditionBest: string;
  conditionHonestAssessment: string;
  grade: string;
  network: string;
  sellFor: string;
  answerAllQuestions: string;
  requestOffer: string;
  processingSale: string[];
  eWasteSaving: string;
  eWasteSavingDescription: string;
  gram: string;
  iPhoneFunctionalityQuestion: string;
  iPhoneFunctionalitySubtitle: string;
  iPhoneScreenConditionQuestion: string;
  iPhoneScreenConditionSubtitle: string;
  iPhoneHousingConditionQuestion: string;
  iPhoneHousingConditionSubtitle: string;
  iPhoneBatteryCapacityQuestion: string;
  iPhoneBatteryCapacitySubtitle: string;
  worksNormally: string;
  hasIssues: string;
  screenPerfect: string;
  screenLightScratches: string;
  screenScratches: string;
  screenMinorDamage: string;
  screenMajorDamage: string;
  housingPerfect: string;
  housingLightScratches: string;
  housingWear: string;
  housingMinorDamage: string;
  housingMajorDamage: string;
  batteryAbove85Percent: string;
  batteryBelow85Percent: string;
  batteryUnknownCapacity: string;
  batteryFull100Percent: string;
  enterBatteryHealth: string;
  enterBatteryHealthSubtitle: string;
  batteryHealthShort: string;
  batteryHealthDisplay: string;
  skip: string;
  save: string;
  howToCheckFunctionality: string;
  checkFunctionalityInstructions: string;
  howToCheckScreen: string;
  checkScreenInstructions: string;
  howToCheckHousing: string;
  checkHousingInstructions: string;
  howToCheckBatteryCapacity: string;
  checkBatteryCapacityInstructions: string;
  functionality: string;
  screen: string;
  housing: string;
  accessories: string;
  charging: string;
  biometrics: string;
  ecoFriendlyRecycling: string;
  ecoFriendlyRecyclingDescription: string;
  chosenSpecs: string;
  stepXOfY: string;
  percentCompleted: string;
  storageInstructionIphone: string;
  explanationTooltip: string;
  messageLimitNote: string;
  successAddCalendar: string;
  successConfirmed: string;
  actionPrint: string;
  actionDownload: string;
  actionShare: string;
  sectionBringAlong: string;
  bringValidId: string;
  confirmingReservation: string;
  // Cancel appointment page (?cancel_order=...&cancel_token=...)
  cancelPageTitle: string;
  cancelOrderNumberLabel: string;
  cancelConfirmQuestion: string;
  cancelConfirmButton: string;
  cancelDeclineButton: string;
  cancelBackHomeButton: string;
  cancelLoadingText: string;
  cancelSuccessTitle: string;
  cancelSuccessText: string;
  cancelAlreadyTitle: string;
  cancelAlreadyText: string;
  cancelTooLateTitle: string;
  cancelTooLateText: string;
  cancelInvalidTitle: string;
  cancelInvalidText: string;
  cancelRateLimitedTitle: string;
  cancelRateLimitedText: string;
  cancelErrorTitle: string;
  cancelErrorText: string;
  cancelNoTokenText: string;
  yourDevices: string;
  contactSoon: string;
  messageSentSuccessfully: string;
  windowClosesAutomatically: string;
  genericError: string;
  calendarServiceError: string;
  chartMonthsAgo: string;
  chartWeeksAhead: string;
  chartMonthsAhead: string;
  chartNow: string;
  outOf: string;
  physicalStoreLocation: string;
  homePickupLocation: string;
  serviceCosts: string;
  noTimeSlotsAvailable: string;
  streetName: string;
  houseNumber: string;
  selectedService: string;
  specificationSingular: string;
  specificationPlural: string;
  serviceTypeStore: string;
  serviceTypeShipping: string;
  selectTimeSlotFirst: string;
  slotJustBooked: string;
  confirmReservationFailed: string;
  previousDevice: string;
  nextDevice: string;
  loading: string;
  errorLoadingModels: string;
  loadingQuestions: string;
  questionsLoadError: string;
  devicesLoadError: string;
  warranty: string;
  warrantyMonths: string;
  reviewsLabel: string;
  serviceLabel: string;
  messageConfirmation: string;
  requestSentTitle: string;
  requestSentDescription: string;
  forExample: string;
  maxPhotosAlert: string;
  somethingWentWrong: string;
  addPhotos: string;
  photosSelected: string;
  photosMaxHint: string;
  describeDevicePlaceholder: string;
  sendRequest: string;
  brandLabel: string;
  modelLabel: string;
  descriptionLabel: string;
  yourNamePlaceholder: string;
  goToStep: string;
  calendarEventTitle: string;
  calendarEventDescription: string;
  calendarFileName: string;
  appointmentConfirmationSubject: string;
  sellDeviceHeroTitle: string;
  sellDeviceHeroSubtitle: string;
  batteryRange85to100: string;
  storageIllustrationAlt: string;
  screenDefectsAlt: string;
  noModelsFound: string;
  tryDifferentSearch: string;
  noModelsAvailable: string;
  checkBackLater: string;
  clearSearch: string;
  selectDeviceTitleRepair: string;
  selectDeviceSubtitleRepair: string;
  repairPromoBadge: string;
  repairPromoTitle: string;
  repairPromoText: string;
  repairPromoButton: string;
  chooseYourMacType: string;
  selectMacTypeSubtitle: string;
  viewModels: string;
  loadMore: string;
  calculating: string;
  slotFullShort: string;
  slotNotAvailable: string;
  successConfirmationSection: string;
  successEmailSentTitle: string;
  successEmailSentDesc: string;
  successEmailSentDescDefault: string;
  successCancellationInfo: string;
  successIdDocsTitle: string;
  successIdDocsDesc: string;
  successTimingSection: string;
  successArrivalTitle: string;
  successArrivalDesc: string;
  successArrivalInfo: string;
  successLocationSection: string;
  successDateSection: string;
  successTimeSection: string;
  successOpenInMaps: string;
  volgende: string;
  bonus: string;
  storeBonusLabel: string;
  storeBonusShort: string;
  pricingError: string;
  rateLimitError: string;
  priceNotFound: string;
  networkError: string;
  retry: string;
  explanation: string;
  inclVat: string;
  deviceValueDropsSingle: string;
  deviceValueDropsMultiple: string;
  sellNowCouldEarn: string;
  liveBadge: string;
  // Allow additional string keys for flexibility
  [key: string]: string | string[];
}

export type Language = 'nl' | 'en' | 'fr' | 'de' | 'es' | 'tr' | 'bg' | 'ro' | 'sk';

export const SUPPORTED_LANGUAGES: Language[] = ['nl', 'en', 'fr', 'de', 'es', 'tr', 'bg', 'ro', 'sk'];

export const DEFAULT_LANGUAGE: Language = 'nl';
